import BaseListPresenter from "../../../../base/BaseListPresenter";
import BiometricDTR from "../../../../components/DTR/BiometricDTR";
export default class TimePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    const dateToDay = new Date();
    this.limit = 50;
    this.where = {
      month: dateToDay.getMonth().toString(),
      year: dateToDay.getFullYear().toString(),
    };
    this.search = {};
    this.filter = {};
    this.include = [];
    this.keys = undefined;
    this.sort = { date: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    // const collection = this.view.getCollectionName();
    const query = this.createQuery();
    const empID = this.view.getCurrent().employee.id;
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const employees = await this.findObjectUseCase.execute("employees", {
        where: { id: empID },
        include: ["employmentType"],
        keys: [
          "biometricId",
          // "selectedSchedule",
          "Firstname",
          "Middlename",
          "surname",
          "region",
          "office",
          "division",
          "section",
          "unit",
          "cluster",
          "twentyFourSeven",
          "employmentType.name",
        ],
      });
      if (employees.length === 0) {
        return;
      }
      const employee = employees[0];
      this.view.setState({ employee });
      try {
        const objects = await BiometricDTR(
          Number(query.where.month),
          Number(query.where.year),
          employee,
        );
        this.objects = this.objects.concat(objects);
        this.view.setObjects(objects);
        this.view.setCurrent(this.current);
        this.hideProgress();
      } catch (e) {
        console.error(e.message || e);
        this.hideProgress();
        this.view.showError(e.message || e);
      }
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }
}
